export default __webpack_public_path__ + "static/media/dimo_showcase1.png";